import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-home",
  "use": "icon-home-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-home\"><path d=\"M704 938.666667H74.666667V337.706667h0.213333L512 85.333333l437.12 252.373334h0.213333V938.666667h-85.333333V391.616h-704V853.333333H704v85.333334zM512 188.373333L160 391.616h704L512 188.373333z\" p-id=\"2074\" /><path d=\"M629.333333 576h85.333334v362.666667h-85.333334z\" p-id=\"2075\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol